
export default {
  props: {
    tile: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },
}
